import { Injectable } from "@angular/core";
import { Route, RouteService } from "@obg/ngx.router";
import { find } from "lodash-es";

import { ActionParamAuthSecureGuard } from "./secure/action-param-auth-secure.guard";
import { AuthSecureGuard } from "./secure/auth-secure.guard";

@Injectable({
	providedIn: "root",
})
export class AuthService {
	constructor(private routeService: RouteService) {}

	isRouteSecure(routeName: string): boolean {
		const route = this.routeService.getRouteConfig(routeName);
		return (
			!!route &&
			!!find(route.canActivate, (token) => token === AuthSecureGuard || token === ActionParamAuthSecureGuard)
		);
	}

	isCurrentRouteSecure(currentRoute: Route): boolean {
		return this.isRouteSecure(currentRoute.name) || !!currentRoute.isFragmentSecure;
	}
}
